module.exports = __webpack_public_path__ + "static/media/hero-image@2x.6b44d56c.png";